export default __webpack_public_path__ + "static/media/ic-instruction-10.6e50a8ba.svg";